import React from "react";
import { Route, Switch } from "react-router-dom";

import { CookieModal } from "../components/cookie-modal";
import { Footer } from "../components/footer";
import { OnboardingBreadcrumbs } from "../components/onboarding-breadcrumbs";
import { OnboardingMobileWarning } from "../components/onboarding-mobile-warning";
import { OnboardingSteps } from "../components/onboarding-steps";
import { SetPassword } from "../components/set-password";
import { useIsMobile, useWindowSize } from "../hooks";

const OnboardingLayout = () => {
  const isMobile = useIsMobile();
  const { width } = useWindowSize();
  const showBreadcrumbs = width >= 1024;

  return (
    <div>
      {isMobile ? (
        <OnboardingMobileWarning />
      ) : (
        <div className="flex">
          <div className={`relative ${showBreadcrumbs ? "col-8" : "full-width"}`}>
            <Switch>
              <Route exact path="/welcome/:orgId/:invitationId" component={SetPassword} />
              <Route path="/welcome" component={OnboardingSteps} />
            </Switch>
            <Footer />
            <CookieModal />
          </div>
          {showBreadcrumbs ? (
            <div className="col-4">
              <OnboardingBreadcrumbs />
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
};

export { OnboardingLayout };
